import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faMapMarkerAlt, faCheckCircle, faCoins
} from '@fortawesome/free-solid-svg-icons';
import './CorporateEntityNode.css';

const CorporateEntityNode = ({ data, selected }) => {
  const isConsolidation = data.in_consolidation_circle;
  const isSelected = selected || data.isSelected;
  const nodeColor = data.node_color || '#4a6b25';

  return (
    <div
      className={`ce-node ${isConsolidation ? 'ce-node-consolidation' : ''} ${isSelected ? 'ce-node-selected' : ''}`}
    >
      <Handle type="target" position={Position.Top} className="ce-handle" />

      <div className="ce-node-header" style={{ backgroundColor: nodeColor }}>
        <div className="ce-node-header-top">
          <div className="ce-node-name">{data.entity_name}</div>
          {isConsolidation && (
            <span className="ce-consol-badge" title="Consolidation Circle">
              <FontAwesomeIcon icon={faCheckCircle} />
            </span>
          )}
        </div>
        {data.trading_short_name && (
          <div className="ce-node-short-name">{data.trading_short_name}</div>
        )}
        {data.shareholder_note && (
          <div className="ce-node-shareholder">{data.shareholder_note}</div>
        )}
      </div>

      <div className="ce-node-body">
        <div className="ce-node-meta-row">
          <span className="ce-node-country">
            <FontAwesomeIcon icon={faMapMarkerAlt} className="ce-info-icon" />
            {data.country}
            {data.country_code && <span className="ce-country-code">{data.country_code}</span>}
          </span>
          <span className="ce-node-currency">
            <FontAwesomeIcon icon={faCoins} className="ce-currency-icon" />
            {data.base_currency}
          </span>
        </div>

        {data.currency_conversion_note && (
          <div className="ce-node-conversion">{data.currency_conversion_note}</div>
        )}
      </div>

      {isConsolidation && <div className="ce-consolidation-indicator" />}

      <Handle type="source" position={Position.Bottom} className="ce-handle" />
    </div>
  );
};

export default memo(CorporateEntityNode);
